import { Box } from "@chakra-ui/react";
import { MailDocument } from "core";
import { collection, CollectionReference, doc } from "firebase/firestore";
import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { useFirestore, useFirestoreDocDataOnce } from "reactfire";
import { WithId } from "../../../types/utils";

export function Mails() {
  return <Outlet />;
}

export function Mail() {
  const { id } = useParams();
  const firestore = useFirestore();
  const { data } = useFirestoreDocDataOnce(
    doc(
      collection(firestore, "mail") as CollectionReference<
        WithId<MailDocument>
      >,
      id
    )
  );

  return (
    <Box>
      {/* <iframe style={{ width: "100%", height: "90vh" }} srcDoc={data?.html} /> */}
    </Box>
  );
}
